import environnement from 'services/app/environment'
import logger from 'redux-logger'

export const nonEmptyValues = () => n => n

export const showLogger = () => (environnement.showReduxLogger() ? logger : null)
